import axios from 'axios';
import queryString from '../../utils/queryString';
import { headers, salesServiceUrl } from '../../config';

export function getSalesOrders(payload) {
    let query = queryString(payload);
    return axios.get(`${salesServiceUrl}/sales-orders?${query}`, { headers: headers() })
}
export function getSalesOrderByValidityDate(payload) {
    let query = queryString(payload);
    return axios.get(`${salesServiceUrl}/blanket-validity-report?${query}`, { headers: headers() });
}